import { Outlet } from 'react-router'
import { Stack, Text } from '@/design-system'
import { Logo } from '@/app/Logo'
import { asset } from '@/lib/assets'
import { BRAND } from '@/brand/brand'
import styles from './AuthLayout.module.css'

const BULLETS = [
  'Spend anywhere with your debit card.',
  'Hold dollars without a US bank account.',
  'Send money in seconds, not days.',
]

const TRUST = [
  { value: 'FCA', label: 'regulated partner' },
  { value: '256-bit', label: 'encryption' },
  { value: '24/7', label: 'human support' },
]

export function AuthLayout() {
  return (
    <div className={styles.shell}>
      <aside
        className={styles.brand}
        style={{ backgroundImage: `url(${asset(BRAND.authPanel)})` }}
      >
        <Logo size={28} tone="dark" />

        <div className={styles.pitch}>
          <Text as="h2" variant="display" weight="bold" tone="onDark">
            {BRAND.authHeadline}
          </Text>
          <Text variant="subtitle" tone="onDarkMuted">
            {BRAND.authSubhead}
          </Text>
          <div className={styles.bullets}>
            {BULLETS.map((bullet) => (
              <div key={bullet} className={styles.bullet}>
                <Text variant="body" tone="accent" weight="bold">
                  —
                </Text>
                <Text variant="body" tone="onDark">
                  {bullet}
                </Text>
              </div>
            ))}
          </div>
        </div>

        <div className={styles.trust}>
          {TRUST.map((item) => (
            <div key={item.value} className={styles.trustItem}>
              <Text variant="body" weight="bold" tone="onDark">
                {item.value}
              </Text>
              <Text variant="caption" tone="onDarkMuted">
                {item.label}
              </Text>
            </div>
          ))}
        </div>
      </aside>

      <main className={styles.panel}>
        <Stack className={styles.form} gap={0}>
          <Logo size={22} className={styles.mobileBrand} />
          <Outlet />
        </Stack>
      </main>
    </div>
  )
}
